import { useEffect, useState } from 'react';
import './tokens-details.css';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { handleError } from '../../../utils';
import http from '../../../core/service/http';


export const useTokensDetailHook = () => {
  const [tokens, setTokens] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [recordCount, setRecordCount] = useState(25);
  const auth = useSelector((state) => state?.appStore?.auth);
  const getTokens = async () => {
    try {
      setLoading(true);
      const response = await http.get("/v1/tokens/");
      if (response.data) {
        setTokens(() =>
          response.data.map((data) => ({
            no: data.id,
            date: data.purchase_date,
            status: data.status,
            token: data.token,
            fee: "£" + data.annual_fee,
          }))
        );
        setLoading(false);
      }
    } catch (error) {
      if (error.response) {
        handleError(error.response.data.message || "Login failed");
      } else {
        handleError("Network error. Please try again later.");
      }
      setLoading(false);
    }
  };

  const filterHandler = (data) => {
    if (searchTerm == "") {
      return true;
    }
    return (
      data.token.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      data.date.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      data.fee.toLowerCase().indexOf(searchTerm.toLowerCase()) > -1 ||
      data.no.toString().indexOf(searchTerm.toLowerCase()) > -1
    );
  };

  useEffect(() => {
    getTokens();
  }, [recordCount]);

  return {
    tokens,
    isLoading,
    setSearchTerm,
    setRecordCount,
    auth,
    filterHandler,
    recordCount
  };
};
